const getLocalStorageUser = (userLocalStorageKey: string) => {
  const user = localStorage.getItem(userLocalStorageKey);
  return user ? JSON.parse(user) : null;
};

export const getUserAuthorization = (userLocalStorageKey: string) =>
  `Bearer ${getLocalStorageUser(userLocalStorageKey)?.access_token}`;
